<template>
  <div>
    <home-search></home-search>
    <home-news></home-news>
  </div>
</template>

<script>
import HomeSearch from "./HomeSearch";
import HomeNews from "./HomeNews";
import { getResource } from "../../vuex/helpers";

import { getNews } from "./HomeActions";

export default {
  components: {
    HomeSearch, HomeNews
  },
  vuex: {
    actions: { getNews, getResource }
  },
  route: {
    data ({ to }) {
      this.getNews();
    }
  }
};
</script>



// WEBPACK FOOTER //
// Home.vue?73d2f8e2